module.exports = __webpack_public_path__ + "static/media/obie.f21e4f9f.png";